import { act } from "react-dom/test-utils";
import { VideoDialogAction } from "../../actions/components/VideoDialogAction";

export interface VideoDialogState {
  title: string;
  message: string;
  btnOnetext: string;
  btnOneOnclick: any;
  onReady: any;
  open: boolean;
  src: string;
}

const initialState = {
  title: "",
  message: "",
  btnOnetext: "",
  btnOneOnclick: "",
  onReady: "",
  open: false,
  src:""
};

export function VideoDialogReducer(
  state: VideoDialogState = initialState,
  action: VideoDialogAction
): VideoDialogState {
  switch (action.type) {
    case "DISPLAY_VIDEO_DIALOG":
      return {
        ...state,
        title: action.payload.title,
        message: action.payload.message,
        btnOnetext: action.payload.btnOnetext,
        btnOneOnclick: action.payload.btnOneOnclick,
        open: true,
        src: action.payload.src
      };
    case "CLOSE_VIDEO_DIALOG":
      return {
        ...state,
        open: false,
      };
    default:
      return state;
  }
}
